export const products = {
  getProductSubtitle: (state) => (productId) => {
    const product = state.products.find(
      ({ id }) => String(id) === String(productId)
    );
    if (!product) return "";
    return product.subtitle;
  },
  getProductTitle: (state) => (productId) => {
    const product = state.products.find(
      ({ id }) => String(id) === String(productId)
    );
    if (!product) return "";
    return product.title;
  },
  getProductPrefix: (state) => (productId) => {
    const product = state.products.find(
      ({ id }) => String(id) === String(productId)
    );
    if (!product) return "";
    return product.prefix;
  },
  getProductPrice: (state) => (productId) => {
    const product = state.products.find(
      ({ id }) => String(id) === String(productId)
    );
    if (!product) return null;
    return product.price;
  },
  getProductCompareAtPrice: (state) => (productId) => {
    const product = state.products.find(
      ({ id }) => String(id) === String(productId)
    );
    if (!product) return null;
    return product.compare_at_price;
  },
  getProductSetPrice: (state) => (productId) => {
    const product = state.products.find(
      ({ id }) => String(id) === String(productId)
    );
    if (!product) return null;
    return product.set_price;
  },
  getProductSetCompareAtPrice: (state) => (productId) => {
    const product = state.products.find(
      ({ id }) => String(id) === String(productId)
    );
    if (!product) return null;
    return product.set_compare_at_price;
  },
};
